export default "__VITE_ASSET__DReXLgXx__"